import classes from './BadgeList.module.scss';
import Badge from '../../atoms/badge/Badge';

const BadgeList = ({ title, data }) => {
    return (
        <>
            <p className={`${classes.aTitle} fnt16f fnt-pm`}>{title}</p>
            <div className={classes.mBadgeList}>
                {data.map((item) => (
                    <Badge text={item.title} theme={item.theme} key={item.id} width={item.width} />
                ))}
            </div>
        </>
    );
};

export default BadgeList;
